<template>

  <h3 class="mt-5"> {{$t('fpmessage.title')}}</h3>
  <el-row justify="center" class="mt-5">
    <el-col :span="19">
      <p style="float: left; font-weight: bold">
        {{$t('fpmessage.mess')}}
      </p>
    </el-col>
  </el-row>
  <!-- 用户名 -->
  <el-row justify="center" class="mt-4">
    <el-col :span="9"
      ><p v-if="username != ''" class="utitle">{{$t('fpmessage.username')}}</p></el-col
    >
    <el-col :span="10"></el-col>
  </el-row>
  <el-row justify="center" :class="[myusername == '' ? 'mt-3' : 'mt-0']">
    <el-col :span="9"
      ><el-input
        id="tuiguangusername"
        v-model="username"
        :placeholder="$t('fpmessage.username')"
        clearable
    /></el-col>
    <el-col :span="10"></el-col>
  </el-row>

  <el-row justify="center">
    <el-col :span="9"
      ><div v-if="usernameempty" class="sfont">{{$t('fpmessage.usernameempty')}}</div></el-col
    >
    <el-col :span="10"></el-col>
  </el-row>

  <!-- 电子邮件 -->
  <el-row justify="center" class="mt-4">
    <el-col :span="9"><p v-if="email != ''" class="utitle">{{$t('fpmessage.email')}}</p></el-col>
    <el-col :span="10"></el-col>
  </el-row>
  <el-row justify="center" :class="[email == '' ? 'mt-3' : 'mt-0']">
    <el-col :span="9"
      ><el-input
        @blur="ValidateEmail"
        v-model="email"
        type="email"
        :placeholder="$t('fpmessage.email')"
        clearable
    /></el-col>
    <el-col :span="10"></el-col>
  </el-row>
  <!-- 邮件合法化检验 -->
  <el-row justify="center" class="mt-0">
    <el-col :span="9"
      ><div v-if="invalidemail" class="sfont">{{$t('fpmessage.emailvalid')}}</div></el-col
    >
    <el-col :span="10"></el-col>
  </el-row>

  <el-row justify="start" class="mt-5">
    <el-col :span="1"></el-col>
    <el-col :span="5">
      <el-button class="mb-5" type="primary" @click="onsendresetpasswd"
        >{{$t('fpmessage.send')}}</el-button
      >
    </el-col>
  </el-row>
</template>

<script>
import { ref, computed, reactive, toRefs } from "vue";
import { orderresetpassword } from "../../js/userhandler";
import { ElMessageBox } from "element-plus";
import {useI18n} from 'vue-i18n'
import { useRouter } from "vue-router";
export default {
  setup() {
    const router = useRouter();
    const username = ref("");
    const email = ref("");
    const {t}=useI18n()
    const state = reactive({
      invalidemail: false,
      submitted: false,
      title:t('fpmessage.title')
    });
    
    const usernameempty = computed(() => {
      if (username.value == "") return true;
      else return false;
    });
    function ValidateEmail() {
      var mailformat =
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      if (email.value.match(mailformat)) {
        state.invalidemail = false;
      } else {
        state.invalidemail = true;
      }
    }
    const onsendresetpasswd = () => {
      if (username.value == "" || email.value == "" || state.invalidemail)
        return;
      else {
        orderresetpassword(username.value, email.value)
          .then((res) => {
            if (res.status == "200") {
              //
              //有可能用户名密码组合错误
              if (res.data.status == "1") {
                ElMessageBox.alert(
                  t('fpmessage.succmess'),
                  t('fpmessage.succtitle'),
                  {
                    type: "success",
                    callback:()=>{router.push("querymap")}
                  },
                );
                
              } else {
                ElMessageBox.alert(
                  t('fpmessage.errmess'),
                  t('fpmessage.errtitle'),
                  {
                    type: "error",
                  }
                );
              }
            }
          })
          .catch(() => {
            ElMessageBox.alert('serve error')
          });
      }
    };

    return {
      usernameempty,
      username,
      email,
      ValidateEmail,
      ...toRefs(state),
      onsendresetpasswd,
    };
  },
};
</script>







<style scoped>
.sfont {
  color: rgb(255, 102, 0);
  font-size: 0.65em;
}
.utitle {
  float: left;
  color: gray;
  font-size: 0.65em;
  margin-bottom: 0.1em;
}
</style>